import { render, staticRenderFns } from "./AsideBannerV2.vue?vue&type=template&id=bd2fd21e&"
import script from "./AsideBannerV2.vue?vue&type=script&lang=js&"
export * from "./AsideBannerV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports